import React, { useReducer, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import '../../elements/FormStyle/FormStyle.css';
import './Password.css';

const Password = () => {
    const { sid } = useParams();

    const formInputReducer = (state, input) => {
        if (input.type === 'reset') {
            return {
                email: '',
                password: ''
            }
        }
        return {
            ...state,
            [input.name]: input.value
        }
    }
    const [formInputs, setFormInputs] = useReducer(formInputReducer, {
        sid: sid,
        password: ''
    })
    const [info, setInfo] = useState('');
    const [submit, setSubmit] = useState(false);
    const [passToggle, setPassToggle] = useReducer(state => !state, false);

    const handlePassword = (e) => {
        e.preventDefault();
        
        setSubmit(true);
        axios.post('https://lerntutors.com/react_2026_api/students/changepassword.php', formInputs)
        .then(res => res.data)
        .then(data => {
            if (data.status === 'success') {
                setInfo(data.message);
                setFormInputs({
                    type: 'reset'
                });
            }
            else {
                setInfo('');
            }
            setSubmit(false);
            setTimeout(() => {
                setInfo('');
                window.location.href = '/logout';
            }, 2000);
        })
    }

    return (
        <div className="lern-password">
            <div className="form-div">
                <form onSubmit={handlePassword}>
                    {info && <p className="alert alert-success text-center">{info}</p>}
                    <fieldset>
                        <legend>Enter New Password</legend>
                        <div className="form-group my-group">
                            <input type={passToggle ? "text" : "password"} name="password" placeholder="New Password" onChange={(e) => setFormInputs(e.target)} value={formInputs.password} required />
                            <span className="input-group-text btn btn-secondary" onClick={setPassToggle}>{passToggle ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}</span>
                        </div>
                        <div className="form-group btn-div">
                            <input type="submit" name="sub-btn" value="Change" disabled={submit} />
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    )
}

export default Password;